import { IOptionData } from "Components/UI/Select";
import {
  FilterOperationType,
  NotificationFilterTypeKeys
} from "Data/interfaces/Notification/IFilters";

export const operationsFormatObj = (t: any): Record<FilterOperationType, (custom?: boolean) => IOptionData> => ({
  equal: (custom?: boolean) => {
    return {
      value: 'equal',
      description: t('filters.filterOperators.equal'),
      label: custom ? '=' : t('filters.filterOperators.equal'),
    }
  },
  between: (custom?: boolean) => {
    return {
      value: 'between',
      description: t('filters.filterOperators.between'),
      label: t('filters.filterOperators.between'),
    }
  },
  before: (custom?: boolean) => {
    return {
      value: 'before',
      description: t('filters.filterOperators.before'),
      label: t('filters.filterOperators.before'),
    }
  },
  after: (custom?: boolean) => {
    return {
      value: 'after',
      description: t('filters.filterOperators.after'),
      label: t('filters.filterOperators.after'),
    }
  },
  onOrBefore: (custom?: boolean) => {
    return {
      value: 'onOrBefore',
      description: t('filters.filterOperators.onOrBefore'),
      label: t('filters.filterOperators.onOrBefore'),
    }
  },
  onOrAfter: (custom?: boolean) => {
    return {
      value: 'onOrAfter',
      description: t('filters.filterOperators.onOrAfter'),
      label: t('filters.filterOperators.onOrAfter'),
    }
  },
});

export const optionsDefaultOperationsObj: Record<NotificationFilterTypeKeys, FilterOperationType> = {
  authorIds: 'equal',
  actions: 'equal',
  csIds: 'equal',
  creationDate: 'equal',
  isRead: 'equal',
};

export const optionsOperationsObj: Record<NotificationFilterTypeKeys, FilterOperationType[]> = {
  authorIds: ['equal'],
  actions: ['equal'],
  csIds: ['equal'],
  creationDate: ['equal', 'between', 'before', 'after', 'onOrBefore', 'onOrAfter'],
  isRead: ['equal'],
};

export const arrayTopicKeysPtBr: Record<string, string> = {
  authorIds: 'Autor',
  actions: 'Ação',
  csIds: 'Obra',
  creationDate: 'Data',
  isRead: 'Lido',
};
